<div class="policy-article-container" cdkScrollable>
  <div class="policy-article-title">
    <ng-content select="[articleTitle]"></ng-content>
  </div>

  <mat-divider></mat-divider>

  <div class="policy-article-body fx-col full-height">
    <ng-content select="[articleBody]"></ng-content>
  </div>
</div>
